import { render, staticRenderFns } from "./ReferenceFileSelectDialog.vue?vue&type=template&id=a57b3a1c&scoped=true&"
import script from "./ReferenceFileSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./ReferenceFileSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceFileSelectDialog.vue?vue&type=style&index=0&id=a57b3a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57b3a1c",
  null
  
)

export default component.exports